module.exports = {"429021100":"松柏镇","429021101":"阳日镇","429021102":"木鱼镇","429021103":"红坪镇","429021104":"新华镇","429021105":"九湖镇","429021200":"宋洛乡","429021202":"下谷坪土家族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/429021.json
// module id = 1803
// module chunks = 0